var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-primary","icon-left":"paper-plane","outlined":"","disabled":""}},[_vm._v(" Submit ")])}
var staticRenderFns = []

export { render, staticRenderFns }